import api from '@pray/shared/utils/api';

export async function getAnnouncementsByArtistId({
  artistId,
  offset,
  limit,
  sortColumn,
  sortDirection,
  contentId,
  search,
  status,
  dateFrom,
  dateTo,
  segmentId,
}) {
  if (!artistId) throw Error('Artist ID is required');

  const params = {};

  if (offset !== undefined && offset !== null) {
    params.offset = offset;
  }

  if (limit) {
    params.limit = limit;
  }

  if (sortColumn) {
    params.sort_column = sortColumn;
  }

  if (sortDirection) {
    params.sort_direction = sortDirection;
  }

  if (contentId) {
    params.content_id = contentId;
  }

  if (search) {
    params.search = search;
  }

  const normalizedStatus = Array.isArray(status) ? status.filter(Boolean).join(',') : status;
  if (normalizedStatus) {
    params.status = normalizedStatus;
  }

  if (dateFrom) {
    params.date_from = dateFrom;
  }

  if (dateTo) {
    params.date_to = dateTo;
  }

  if (segmentId) {
    params.segment_id = segmentId;
  }

  const url = `/web/studio/artists/${artistId}/announcements`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
}
